import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Wizard from "@/pages/Wizard";
import Results from "@/pages/Results";
import ExampleResult from "@/pages/ExampleResult";
import SharedResults from "@/pages/SharedResults";

export default function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/simuler" element={<Wizard />} />
        <Route path="/resultats" element={<Results />} />
        <Route path="/mes-resultats" element={<SharedResults />} />
        <Route path="/exemple" element={<ExampleResult />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
